/*
 * VolumeSlider.tsx
 * Anvilo, Inc.
 *
 *
 * Created by Artem Yefimenko on 13/05/2020
 * Copyright (c) 2020 Anvilo, Inc. All right reserved.
 */

import React, { useState } from "react";
import Grid from "@material-ui/core/Grid";
import Slider from "@material-ui/core/Slider";
import VolumeMuteIcon from "@material-ui/icons/VolumeMute";
import VolumeUp from "@material-ui/icons/VolumeUp";
import MicIcon from "@material-ui/icons/Mic";
import MicOffIcon from "@material-ui/icons/MicOff";
import { withStyles } from "@material-ui/core";
import { useDispatch } from "react-redux";
import {
  setAudioOutputVolume,
  setAudioInputVolume,
} from "../../actions/preferencesActions";
import { useAppSelector } from "@helpers/hooks/useAppSelector.hook";

type StyleTypeFunc = () => {[name: string]: {[name: string]: string}}

const deviceTypes = {
  INPUT: "audioinput",
  OUTPUT: "audiooutput",
};

const styles: StyleTypeFunc = () => ({
  volumeDownContainer: {
    display: "flex",
    alignItems: "center",
  },
  volumeSliderContainer: {
    display: "flex",
    alignItems: "center",
    paddingTop: "10px !important",
  },
  volumeUpContainer: {
    alignItems: "center",
    display: "flex",
  },
});

type Props = {
  deviceType: "audioinput" | "audiooutput"
  classes: any
}

const VolumeSlider: React.FC<Props> = ({ deviceType, classes }) => {
  const reduxVolume = useAppSelector(state =>
    deviceType === deviceTypes.OUTPUT
      ? state.preferences.defaultAudioOutputVolume
      : state.preferences.defaultAudioInputVolume
  );

  const [volume, setVolume] = useState(reduxVolume);
  const dispatch = useDispatch();

  const changeOutputVolume = (newVolume: number) => {
    dispatch(setAudioOutputVolume(newVolume));
  };

  const changeInputVolume = (newVolume: number) => {
    dispatch(setAudioInputVolume(newVolume));
  };

  return (
    <>
      <div style={{ padding: "5px 0" }} className="none-select-text">
        Volume
      </div>
      <Grid style={{ maxWidth: 400 }} container spacing={2}>
        <Grid item className={classes.volumeDownContainer}>
          {deviceType === deviceTypes.OUTPUT ? (
            <VolumeMuteIcon
              onClick={() => {
                changeOutputVolume(0);
                setVolume(0);
              }}
            />
          ) : (
            <MicOffIcon
              onClick={() => {
                changeInputVolume(0);
                setVolume(0);
              }}
            />
          )}
        </Grid>
        <Grid item xs className={classes.volumeSliderContainer}>
          <Slider
            style={{
              color: "orange",
            }}
            min={0}
            max={1}
            step={0.01}
            value={volume}
            onChange={(e, newValue) => {
              const volume = Number(newValue);
              if (deviceType === deviceTypes.OUTPUT) {
                changeOutputVolume(volume);
              }
              setVolume(volume);
            }}
            onChangeCommitted={(e, newValue) => {
              const volume = Number(newValue);
              if (deviceType === deviceTypes.INPUT) {
                changeInputVolume(volume);
              }
            }}
          />
        </Grid>
        <Grid item className={classes.volumeUpContainer}>
          {deviceType === deviceTypes.OUTPUT ? (
            <VolumeUp
              onClick={() => {
                changeOutputVolume(1);
                setVolume(1);
              }}
            />
          ) : (
            <MicIcon
              onClick={() => {
                changeInputVolume(1);
                setVolume(1);
              }}
            />
          )}
        </Grid>
      </Grid>
    </>
  );
}

export default withStyles(styles)(VolumeSlider);
